<template>
  <div>
    <h3>{{$t('Procedimiento')}}</h3>
    <p>Formulario para subir procedimiento de empresa contratista.</p>
    <!-- *el procedimiento deberia quedar disponible en la plataforma para posteriores usos. -->
    <table class="newProcedureTable">
      <tbody>
        <tr>
          <th>{{$t('Título')}}</th>
          <td>
            <el-input v-model="newProcedure.title" placeholder="Ingrese título del procedimiento"/>
          </td>
        </tr>
        <tr>
          <th>{{$t('Fecha de creación')}}</th>
          <td>
            <el-date-picker
              class="full-width"
              type="date"
              placeholder="Ingrese Fecha de creación"
              v-model="newProcedure.document_date"/>
          </td>
        </tr>
        <tr>
          <th>{{$t('Fecha de revisión')}}</th>
          <td>
            <el-date-picker
              class="full-width"
              type="date"
              placeholder="Ingrese Fecha de revisión"
              v-model="newProcedure.inspection_date"/>
          </td>
        </tr>
        <tr>
          <th>{{$t('Código')}}</th>
          <td>
            <el-input v-model="newProcedure.serial" placeholder="Ingresar código"/>
          </td>
        </tr>
        <tr>
          <th>{{$t('Archivo')}}</th>
          <td>
            <label :for="`file-upload-${id}`" class="custom-file-upload3">
              <i class="el-icon-paperclip"></i>
              <span>{{$t('Adjuntar archivo')}}</span>
              <input :id="`file-upload-${id}`" class="btn" type="file" @change="selectFile($event.target.files)">
            </label>
          </td>
        </tr>
        <tr v-if="fileName">
          <td colspan="2">{{fileName}}</td>
        </tr>
      </tbody>
    </table>
    
    <div style="text-align:center">
      <el-button type="primary" @click="save" :disabled="checked">
        <b>{{$t('Subir Procedimiento')}}</b>
      </el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import uuid from 'uuid/v4';
import {
  addProcedure,
  addRole,
} from '@/procedures/requests.js';

export default {
  props: {
    dialog: {
      default:false
    },
    procedures: {
      default: ()=>[]
    }
  },
  data() {
    return {
      id: uuid(),
      fileName: '',
      newProcedure: {
        title: '',
        document_date: null,
        inspection_date: null,
        pdf_document: null,
        serial: '',
      },
    };
  },
  computed: {
    checked() {
      const chList = Object.keys(this.newProcedure);
      const res = chList.filter(v => !!this.newProcedure[v]);

      return res.length != chList.length;
    },
    role() { return this.$store.getters.role },
    jobId() { return this.role.faena_id },
    empresa_id() { return this.role.empresa_id; },
    inventory_data() { // registro en la tabla de procedimiento que asocia proc standar con la tarea
      return this.selectedProcedures.find(f => f.task_id === this.taskId)
    },
    myId() {
      return this.$store.getters.user._id;
    },
  },
  created() { },
  methods: {
    selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
      this.newProcedure.pdf_document = files[0];
      this.fileName = files[0].name;
		},
    save() {
      //validar q esten todos los campos
      const proc = {...this.newProcedure}
//
      proc.vendor_inventory_id = this.empresa_id;
      proc.inspection_date = moment(new Date(proc.inspection_date)).format("YYYY-MM-DD");
      proc.document_date = moment(new Date(proc.document_date)).format("YYYY-MM-DD");

      proc.job_id = this.jobId;

      addProcedure(proc)
        .then(r => {
          if(r.id) {
            this.procedures.push(r);
            //agregar roles
            addRole({
              name: 'Elaborador',
              user_id: this.myId,
              status: 0,
              procedure_id:r.id,
            }).catch(e => console.error(e));
            addRole({
              name: 'Aprobador',
              user_id: this.myId,
              status: 2,
              procedure_id:r.id,
            }).catch(e => console.error(e));
            this.$alert(this.$t('Procedimiento guardado'),
              this.$t('Atención'),
              { type: 'success' },
            );
          } else {
            this.$alert(this.$t('Ocurrio un problema al guardar el procedimiento'),
              this.$t('Atención'),
              { type: 'error' },
            );
            //avisar error
          } // if
          this.newProcedure.title = '';
          this.newProcedure.document_date = null;
          this.newProcedure.inspection_date = null;
          this.newProcedure.pdf_document = null;
          this.newProcedure.serial = '';
          this.fileName = '';
          this.$emit('update:dialog', false);
        })
        .catch(e => {
          this.$alert(this.$t('Ocurrio un problema al guardar el procedimiento'),
            this.$t('Atención'),
            { type: 'error' },
          );
          console.error(e);
          this.$emit('update:dialog', false);
        });
    }// save
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.img_pdf{
  height: 30px;
  margin-bottom: 5px;
}
.newProcedureTable th{
  text-align: left;
  margin-right: 5px;
}
.newProcedureTable tr{
  height: 50px;
}
.newProcedureTable{
  margin-bottom: 20px; 
}
.custom-file-upload3{
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  width: 100%;
}
</style>
